export interface IAppContext {
    userBrowser: any;
}

declare let document: any;
declare let opr: any;
declare let InstallTrigger: any;
declare let safari: any;
declare let window: ng.IWindowService;

export const appContext: IAppContext = (() => {
    let isIE = /*@cc_on!@*/false || !!document.documentMode;
    let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    let isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    /* tslint:disable:no-string-literal */
    const _userBrowser = {
        'isOpera': isOpera,
        'isFirefox': typeof InstallTrigger !== 'undefined',
        'isSafari': /constructor/i.test(window.HTMLElement) || (function (p: any) { return p.toString() === '[object SafariRemoteNotification]'; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification)),
        'isIE': isIE,
        'isEdge': !isIE && !!window.StyleMedia,
        'isChrome': isChrome,
        'isBlink': (isChrome || isOpera) && !!CSS
    };
    /* tslint:enable:no-string-literal */

    return {
        userBrowser: _userBrowser
    };
})();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/app.context.ts